import contentDialog from '~/mixins/dialogs/contentDialog'
import confirmationDialog from '~/mixins/dialogs/confirmationDialog'
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'

const tags = {
  mixins: [contentDialog, confirmationDialog, informationSnackbar],
  computed: {
    tagActions() {
      return [
        {
          name: 'edit',
          text: 'Edit',
          icon: 'pen-edit',
          call: tag => this.editTag(tag)
        },
        {
          name: 'display',
          text: 'Display',
          icon: 'arrow-right',
          innerMenu: this.displayTagOptions
        },
        {
          name: 'delete',
          text: 'Delete',
          icon: 'danger-trash',
          call: tag => this.deleteTag(tag)
        }
      ]
    },
    displayTagOptions() {
      return [
        {
          name: 'showtagdocuments',
          text: 'Show',
          value: true,
          call: (tag, value) => this.onTagVisibleChange(tag, value)
        },
        {
          name: 'hidetagdocuments',
          text: 'Hide',
          value: false,
          call: (tag, value) => this.onTagVisibleChange(tag, value)
        }
      ]
    }
  },
  methods: {
    async documentsTableUpdate() {
      await this.$store.dispatch('documents/getAll')
    },
    async getTags() {
      try {
        await this.$store.dispatch('tags/getAll')
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    async createTag({ document = null, documents = null }) {
      await this.contentDialog.open({
        width: '512px',
        component: 'form-tag',
        componentProps: {
          document,
          documents,
          tableRequest: this.documentsTableUpdate
        }
      })
    },
    async editTag(tag) {
      await this.contentDialog.open({
        width: '512px',
        component: 'form-tag',
        componentProps: {
          isEdit: true,
          item: tag,
          tableRequest: this.documentsTableUpdate
        }
      })
    },
    async deleteTag(tag) {
      await this.confirmationDialog.open({
        title: this.$t('Remove tag'),
        text: this.$t('Documents are labeled by this tag {tagName} will not deleted', {
          tagName: tag.name
        }),
        buttons: {
          approve: {
            text: this.$t('Delete')
          },
          dismiss: {
            text: this.$t('Cancel')
          }
        },
        icon: {
          src: require('~/assets/images/warning.png'),
          maxWidth: 80
        },
        onConfirm: async () => {
          await this.$store.dispatch('tags/delete', { id: tag.id })
          if (this.$route.params.id === this.tag.id) {
            await this.$router.push({ name: 'documents' })
          } else {
            await this.documentsTableUpdate()
          }
          await this.informationSnackbar.open({
            text: this.$t('Tag has been successfully deleted')
          })
        }
      })
    },
    async toggleDocumentTag({ id, tagId, tagName, isDelete, loading }) {
      try {
        loading[tagId] = true
        const payload = {
          tagIds: [tagId]
        }
        if (isDelete) {
          await this.$store.dispatch('documents/deleteTag', { id, tagId })
          await this.informationSnackbar.open({
            text: this.$t('Tag {tagName} has deleted from document', {
              tagName
            }),
            buttonText: 'Cancel',
            buttonTextVariant: true,
            onButtonClick: async () => {
              try {
                await this.$store.dispatch('documents/addTags', { id, payload })
                await this.$store.dispatch('documents/read', { id })
              } catch (e) {
                this.$handlers.error(e, this)
              }
            }
          })
        } else {
          await this.$store.dispatch('documents/addTags', { id, payload })
          await this.informationSnackbar.open({
            text: this.$t('Tag {tagName} has added to document', {
              tagName
            }),
            buttonText: 'Cancel',
            buttonTextVariant: true,
            onButtonClick: async () => {
              try {
                await this.$store.dispatch('documents/deleteTag', { id, tagId })
                await this.$store.dispatch('documents/read', { id })
              } catch (e) {
                this.$handlers.error(e, this)
              }
            }
          })
        }
        await this.$store.dispatch('documents/read', { id })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        loading[tagId] = false
      }
    },
    async addTagToDocuments({ documentIds, tagId, tagName, loading }) {
      try {
        loading[tagId] = true
        const payload = {
          tagIds: [tagId],
          documentIds
        }
        await this.$store.dispatch('documents/attachTags', payload)
        await this.documentsTableUpdate()
        this.$emit('clear')
        await this.informationSnackbar.open({
          text: this.$t('Tag {tagName} has added to documents', {
            tagName
          }),
          buttonText: 'Have a look',
          buttonClass: 'main-button',
          onButtonClick: () => {
            this.$router.push({ name: 'tags-id', params: { id: tagId } })
          }
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        loading[tagId] = false
      }
    },
    async onTagVisibleChange(item, value) {
      if (value === item.showInDocuments) {
        return
      }
      const payload = { ...item, showInDocuments: !item.showInDocuments }
      try {
        await this.$store.dispatch('tags/update', { id: item.id, payload })
        await this.documentsTableUpdate()
        // todo: maybe show some message
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}

export default tags
